import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgSpinner(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 0 16 24" {...props}>
      <path
        d="M9.327 4.378L10.382 4l.757 2.11-1.055.378a5.807 5.807 0 00-3.842 5.466 5.801 5.801 0 005.798 5.805 5.801 5.801 0 005.474-3.885l.37-1.057 2.116.74-.37 1.057A8.043 8.043 0 0112.04 20C7.6 20 4 16.397 4 11.954a8.048 8.048 0 015.327-7.576z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Spinner')(SvgSpinner);
